"use strict";
var controller = function($scope, $rootScope, $http, urls) {
  $scope.getList = function() {
    $scope.loading = true;
    var params = {
      "name": $scope.query,
      "page": $scope.page,
      "per_page": $scope.per_page
    };
    $http.get('api/user.json', {params: params}).success(function(data, status, headers, config) {
      $scope.users = data.users;
      $scope.count = data.count;
    }).catch(function(data, status, headers, config) {}).finally(function() {
      $scope.loading = false;
    });
  };
  $scope.refresh = function() {
    $scope.getList();
  };
  $scope.$watch('page', function() {
    $scope.getList();
  });
  var init = function() {
    $scope.urls = urls;
    $scope.per_page = 20;
    $scope.page = 1;
    $scope.count = 0;
    $scope.getList();
  }();
};
module.exports = controller;
